import React from "react";
import toastr from "toastr";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const UpdateInventory = () => {
  const [edit, setEdit] = useState("");
  const [inventory, setInventory] = useState({
    price: "",
    stock: "",
  });
  const history = useHistory();
  const location = useLocation();
  const { productId } = location.state;

  useEffect(() => {
    axios
      .get(`http://api.meddaily.in/editproduct/${productId}`)
      .then((response) => {
        setEdit(response?.data?.data[0]);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  const { title, _id, sub_title } = edit;

  const { price, stock } = inventory;

  console.log("edit", edit);

  const handleUpdate = async (e) => {
    e.preventDefault();
    const authToken = localStorage.getItem("disToken");
    const disId = localStorage.getItem("id");
    const disName = localStorage.getItem("disName");
    debugger;
    if (stock === "") {
      return toastr.warning("stock cannot be empty !");
    }
    if (price === "") {
      return toastr.warning("price cannot be empty !");
    }
    // if (
    //   !edit.distributors ||
    //   edit.distributors.length === 0 ||
    //   !edit.distributors[0].distributorName
    // ) {
    //   return toastr.warning("Distributor name cannot be empty!");
    // }
    const reqBody = {
      productId: _id,
      distributorId: disId,
      distributorName: disName,
      price: price,
      stock: stock,
    };
    const axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        token: `${authToken}`,
      },
    };
    try {
      const response = await axios.post(
        `http://api.meddaily.in/update_inventory`,
        reqBody,
        axiosConfig
      );
      console.log(response);
      if (response.status === 200) {
        toastr.success(response.data.message);
        setInventory({
          name: "",
          price: "",
          stock: "",
        });
        history.push("/myinventory");
      }
      //   console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setInventory({
      price: "",
      stock: "",
    });
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Sidebar />

          <div className="layout-page">
            <Navbar />
            <h3 className="mt-3">Update The Inventory </h3>
            <div className="mt-3 m-5">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title text-start mb-3">{title}</h5>
                  <h6 className="card-subtitle mb-2 text-muted text-start">
                    {sub_title}
                  </h6>
                </div>
              </div>
              <div className="card mt-3">
                <div className="card-body">
                  <form>
                    <div className="form-group col-md-6 text-start mb-3">
                      <label for="updateStock">Update Stock</label>
                      <input
                        type="number"
                        className="form-control"
                        id="updateStock"
                        value={stock}
                        onChange={(e) =>
                          setInventory((prevInventory) => ({
                            ...prevInventory,
                            stock: e.target.value,
                          }))
                        }
                      />
                    </div>

                    <div className="form-group col-md-6 text-start mb-3">
                      <label for="updatePrice">Update Price</label>
                      <input
                        type="number"
                        className="form-control"
                        id="updatePrice"
                        value={price}
                        onChange={(e) =>
                          setInventory((prevInventory) => ({
                            ...prevInventory,
                            price: e.target.value,
                          }))
                        }
                      />
                    </div>

                    <div className="text-center">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={handleUpdate}
                        style={{
                          backgroundColor: "#6eafab",
                          border: "1px solid #6eafab",
                        }}
                      >
                        Update
                      </button>
                      <button
                        type="reset"
                        className="btn btn-outline-secondary m-3"
                        onClick={handleCancel}
                      >
                        cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              {/* <form id="formAccountSettings">
                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label for="name" className="form-label float-start">
                     Name
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="name"
                      name="name"
                      value={sub_title}
                      onChange={handle}
                      autoFocus
                    />
                  </div>
                  <div className="mb-3 col-md-6">
                    <label for="productname" className="form-label float-start">
                      Product Name
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="productname"
                      id="productname"
                      defaultValue={title}
                      readOnly
                    />
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label float-start" for="price ">
                      Price
                    </label>
                    <div className="input-group input-group-merge">
                      <input
                        type="number"
                        id="price"
                        name="price"
                        className="form-control"
                        placeholder="100"
                        value={price}
                        onChange={handle}
                      />
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label for="stock" className="form-label float-start">
                      Stock
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      id="stock"
                      name="stock"
                      placeholder="20"
                      value={stock}
                      onChange={handle}
                    />
                  </div>
                </div>
                <button className="btn btn-primary" onClick={handleUpdate}>
                  Update
                </button>
                <button
                  className="btn btn-secondary mx-3"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </form> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateInventory;
